import { bookingChannelLogic } from './bookingChannelLogic';
import { updatePaymentsLogic } from './updatePaymentsLogic';

export const logic = [bookingChannelLogic, updatePaymentsLogic];
